export const VIEW_MODES = {
  HEATMAP: 'heatmap',
  HEATMAPCLUSTERS: 'heatmapclusters',
  COLDMAP: 'coldmap',
  OVERLAY: 'overlay',
  OVERLAYCLUSTERS: 'overlayclusters',
  SPOTLIGHT: 'spotlight',
  DOTS: 'dots',
  ORIGINAL: 'original',
  CLUSTERS: 'clusters'
}

export const DOT_RADIUS = 6
export const DOT_RADIUS_SM = 1.5

export const HEATMAP_COLORS = ['#00FF00', '#FFFF00', '#FF0000']
export const COLDMAP_COLORS = ['#B7E5D9', '#5CCBC5', '#233D64']
export const OVERLAY_COLORS = ['#00FF00', '#FFFF00', '#FF0000']

export const HEATMAP_OPACITY = [0.2, 1]
export const OVERLAY_OPACITY = [0.3, 1]
export const HEATMAPCLUSTERS_OPACITY = [0.2, 0.95]

export const EXPORT_OPTIONS = [
  { text: 'Download PNG image', key: 'png' },
  { text: 'Download JPEG image', key: 'jpeg' },
  { text: 'Download PDF document', key: 'pdf' },
  { text: 'Download EPS file', key: 'eps' }
]

export const CLUSTER_STROKE_WIDTH = 3
